// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-group-row .product-group-name[data-v-457bd4d7]{font-size:2rem}", ""]);
// Exports
module.exports = exports;
